import { render, staticRenderFns } from "./SensorSetting.vue?vue&type=template&id=cc28a6ce&scoped=true"
import script from "./SensorSetting.vue?vue&type=script&lang=js"
export * from "./SensorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc28a6ce",
  null
  
)

export default component.exports